import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { Employee } from 'src/types/Employee';
import {
  removePhoneNumberFormatting,
  getFormattedPhoneNumber,
} from 'src/components/PhoneMaskInput/PhoneMaskInput';

export function transformPhoneNumberUIToModel(
  values: Partial<EmployeeFormFields>
): Partial<EmployeeFormFields> {
  return {
    ...values,
    phoneNumber: removePhoneNumberFormatting(values.phoneNumber),
  };
}

export function transformPhoneNumberModelToUI(
  values: Partial<Employee>
): Partial<EmployeeFormFields> {
  return {
    ...values,
    phoneNumber: getFormattedPhoneNumber(values.phoneNumber),
  };
}
